@if (!hasNoContent()) {
<ob-alert type="info">{{ "i18n.table.alert.title" | translate }}</ob-alert>
}
